import L, { LeafletEventHandlerFnMap } from 'leaflet';
import { Marker } from 'react-leaflet';
import 'leaflet-rotatedmarker';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { RotationModel } from '../utils';
import { CustomPaneName } from '../../mapConfig';

export interface RotatableMarkerProps extends RotationModel {
  icon: L.Icon;
  eventHandlers?: LeafletEventHandlerFnMap;
  pane?: CustomPaneName;
}

export function RotatableMarker({
  icon,
  position,
  heading,
  eventHandlers,
  pane,
  children,
}: PropsWithChildren<RotatableMarkerProps>) {
  const ref = useRef<L.Marker>(null);

  const safeHeading = heading ?? 0;

  useEffect(() => {
    ref.current?.setRotationAngle(safeHeading);
  }, [safeHeading]);

  // Note: ReactLeaflet allows providing an 'undefined' pane, but it triggers a runtime error.
  // Only add a pane name prop if one has been defined.
  const paneProp = pane ? { pane } : {};

  return (
    <Marker
      {...paneProp}
      ref={ref}
      icon={icon}
      position={position}
      rotationAngle={safeHeading}
      eventHandlers={eventHandlers}
    >
      {children}
    </Marker>
  );
}

export default RotatableMarker;
